import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import theme from "themes/simple-theme";

interface IProps {
  goodPin?: boolean;
  wrongPin?: boolean;
}

const PinStatusIcon = styled(FontAwesomeIcon)`
  position: absolute;
  right: -7rem;
  top: -0.5rem;
  font-size: 64px;
  ${({ goodPin }: IProps) => (goodPin ? `color: ${theme.color.tertiary}` : ``)};
  ${({ wrongPin }: IProps) => (wrongPin ? `color: ${theme.color.red}` : ``)};
`;

export default PinStatusIcon;



// WEBPACK FOOTER //
// ./src/components/common/PinInput/PinStatusIcon.tsx